import {FormValues} from '@wix/form-viewer'
import {
  BUYER_FORM_HEADER_ID,
  BUYER_FORM_SUBMIT_BUTTON_ID,
  RSVP_FORM_HEADER_ID,
  RSVP_FORM_SUBMIT_BUTTON_ID,
  TICKET_HOLDER_FORM_HEADER_ID,
  TICKET_HOLDER_FORM_SUBMIT_BUTTON_ID,
} from '@wix/wix-events-commons-statics'

interface BuildOverridesParams {
  initialValues: FormValues
  member: boolean
  ticketed: boolean
  useBuyerDetails?: boolean
}

export const buildOverrides = ({initialValues, member, ticketed, useBuyerDetails}: BuildOverridesParams) => {
  let overrides = {}

  if (initialValues.email && member) {
    overrides = {email: {disabled: true}}
  }

  if (useBuyerDetails) {
    overrides = {
      ...overrides,
      first_name: {disabled: true},
      last_name: {disabled: true},
      email: {disabled: true},
    }
  }

  if (ticketed) {
    overrides = {
      ...overrides,
      [BUYER_FORM_HEADER_ID]: {hidden: true},
      [BUYER_FORM_SUBMIT_BUTTON_ID]: {hidden: true},
      [TICKET_HOLDER_FORM_HEADER_ID]: {hidden: true},
      [TICKET_HOLDER_FORM_SUBMIT_BUTTON_ID]: {hidden: true},
    }
  } else {
    overrides = {
      ...overrides,
      [RSVP_FORM_HEADER_ID]: {hidden: true},
      [RSVP_FORM_SUBMIT_BUTTON_ID]: {hidden: true},
    }
  }

  return overrides
}
